@import '../../styles/fonts.scss';
@import '../../styles/palette.scss';

.section {
  display: flex;
  flex-direction: column;
  .row {
    display: flex;
    margin-top: 1em;

    .checkboxElements {
      display: flex;
      flex: 2;
      flex-wrap: wrap;

      .checkboxElement {
        display: flex;
        align-items: center;
        flex: 1;
      }
    }
  }

  .title {
    @include barlowMedium(18);
    padding: 1em 1em 1em 0;
    flex: 1;
  }

  .button {
    margin-top: 2em;
    align-self: flex-end;
  }
}
